export const createHouseLink = ({ newbuildingId, houseId }: { newbuildingId: number; houseId: number }) => {
  return `https://www.cian.ru/cat.php?deal_type=sale&engine_version=2&offer_type=flat&from_developer=1&nb_house_key%5B0%5D=${newbuildingId}_${houseId}`;
};
